/**
 * Resolves the sub-app base URL from the SPA's current hostname.
 *
 * Production routing:
 *   app.heybesafe.com         -> https://subscribe.heybesafe.com   (live alias)
 *   app-blue.heybesafe.com    -> https://subscribe-blue.heybesafe.com
 *   app-green.heybesafe.com   -> https://subscribe-green.heybesafe.com
 *   app-test.heybesafe.com    -> https://subscribe-test.heybesafe.com
 *   heybesafe.com / www.*     -> https://subscribe.heybesafe.com
 *
 * Same runtime-not-build-time rationale as resolveApiBaseUrl: a CDK
 * cutover that flips subscribe.* between blue and green should not also
 * require a SPA rebuild + S3 sync.
 */
export function resolveSubscribeBaseUrl(
  hostname: string,
  fallback: string | undefined,
): string {
  if (hostname === 'app.heybesafe.com') return 'https://subscribe.heybesafe.com';
  if (hostname === 'heybesafe.com' || hostname === 'www.heybesafe.com') {
    return 'https://subscribe.heybesafe.com';
  }
  const colorMatch = hostname.match(/^app-(blue|green|test)\.heybesafe\.com$/);
  if (colorMatch) return `https://subscribe-${colorMatch[1]}.heybesafe.com`;
  return fallback ?? 'https://subscribe.heybesafe.com';
}
